const afterSalesList = {
    path: 'aftersales',
    component: resolve => require(['@/pages/admin/agent/aftersales/index'], resolve)
}

export default afterSalesList